var map = {
	"./de/download-note-text.png": "yXE2",
	"./en/download-note-text.png": "IkFL",
	"./es/download-note-text.png": "i82x",
	"./fr/download-note-text.png": "MskU",
	"./ja/download-note-text.png": "KUXP",
	"./ko/download-note-text.png": "Q2AH",
	"./pt/download-note-text.png": "EiMB",
	"./ru/download-note-text.png": "6pZQ",
	"./tc/download-note-text.png": "JoHZ",
	"./th/download-note-text.png": "MfBe",
	"./zh-Hant/download-note-text.png": "VvMp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Jbg0";